(() => {
  'use strict';
  function init(scope = document) {
    scope.querySelectorAll('[data-reference-carousel]').forEach(carousel => {
      if (carousel.dataset.bound) return;
      carousel.dataset.bound = 'true';
      const track = carousel.querySelector('[data-reference-track]');
      if (!track) return;
      const buttons = [...carousel.querySelectorAll('[data-reference-step]')];
      const dots = [...carousel.querySelectorAll('[data-reference-index]')];
      const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const reviews = [...carousel.querySelectorAll('[data-review-toggle]')].map(toggle => ({
        toggle,
        quote: toggle.closest('.zj-tm__quote'),
        text: document.getElementById(toggle.getAttribute('aria-controls'))
      }));
      carousel.classList.add('has-review-toggles');
      reviews.forEach(({toggle, quote}) => toggle.addEventListener('click', () => {
        const expanded = quote.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? 'Read less' : 'Read more';
      }));
      function update() {
        reviews.forEach(({toggle, quote, text}) => {
          if (!text || quote.classList.contains('is-expanded')) return;
          toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
        });
        const max = track.scrollWidth - track.clientWidth;
        buttons.forEach(button => {
          button.disabled = Number(button.dataset.referenceStep) < 0 ? track.scrollLeft <= 1 : track.scrollLeft >= max - 1;
          if (dots.length) button.hidden = max <= 1;
        });
        if (dots.length) {
          const cards = [...track.children], step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
          const active = Math.round(track.scrollLeft / step), last = Math.ceil(max / step);
          dots.forEach((dot, i) => { dot.hidden = max <= 1 || i > last; dot.setAttribute('aria-pressed', String(i === active)); });
        }
      }
      buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({left:Number(button.dataset.referenceStep) * track.clientWidth * .85,behavior:behavior()})));
      dots.forEach(dot => dot.addEventListener('click', () => {
        const cards = [...track.children], card = cards[Number(dot.dataset.referenceIndex)];
        if (card) track.scrollTo({left:card.offsetLeft - cards[0].offsetLeft,behavior:behavior()});
      }));
      track.addEventListener('scroll', update, {passive:true});
      const observer = new ResizeObserver(update); observer.observe(track);
      document.addEventListener('shopify:section:unload', function cleanup(event) {
        if (event.target.contains(carousel)) { observer.disconnect(); document.removeEventListener('shopify:section:unload',cleanup); }
      });
      update();
      if (document.fonts) document.fonts.ready.then(update);
    });
  }
  document.addEventListener('shopify:section:load',event => init(event.target));
  init();
})();
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-reference-announcement]').forEach(bar => {
      if (bar.dataset.bound) return;
      bar.dataset.bound = 'true';
      const slides = [...bar.querySelectorAll('[data-announcement-slide]')].filter(slide => slide.textContent.trim());
      const button = bar.querySelector('[data-announcement-pause]');
      if (!button) return;
      let index = 0, paused = false;
      bar.querySelectorAll('[data-announcement-slide]').forEach(slide => { slide.hidden = slide !== slides[0]; });
      button.hidden = slides.length < 2;
      const sync = () => {
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', (paused ? button.dataset.playLabel : button.dataset.pauseLabel) || (paused ? 'Play announcements' : 'Pause announcements'));
        button.textContent = paused ? '▶' : 'Ⅱ';
      };
      sync();
      button.addEventListener('click', () => { paused = !paused; sync(); });
      const timer = setInterval(() => {
        // Keep a focused message link stable; the play/pause control may retain focus.
        if (paused || document.hidden || slides.length < 2 || slides.some(slide => slide.contains(document.activeElement))) return;
        slides[index].hidden = true;
        index = (index + 1) % slides.length;
        slides[index].hidden = false;
      }, 4500);
      document.addEventListener('shopify:section:unload', function cleanup(event) {
        if (event.target.contains(bar)) {
          clearInterval(timer);
          document.removeEventListener('shopify:section:unload', cleanup);
        }
      });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();

(() => {
  function init(scope = document) {
    scope.querySelectorAll('#mobile-dialog').forEach(dialog => {
      if (dialog.dataset.mobileBound) return;
      dialog.dataset.mobileBound = 'true';
      const trigger = document.querySelector('[data-open="mobile-dialog"]');
      dialog.querySelectorAll('.reference-mega > div').forEach(group => {
        const heading = group.querySelector('.reference-mega-heading');
        if (!heading) return;
        const details = document.createElement('details'), summary = document.createElement('summary');
        details.className = 'mobile-menu-group';
        summary.textContent = heading.textContent;
        const chevron = dialog.querySelector('.submenu-chevron')?.cloneNode(true);
        if (chevron) summary.append(chevron);
        group.before(details); details.append(summary, group);
      });
      dialog.addEventListener('close', () => trigger?.setAttribute('aria-expanded', 'false'));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      const desktop = matchMedia('(min-width: 851px)');
      const resize = () => { if (desktop.matches && dialog.open) dialog.close(); };
      desktop.addEventListener('change', resize);
      document.addEventListener('shopify:section:unload', function cleanup(event) {
        if (event.target.contains(dialog)) { desktop.removeEventListener('change',resize); document.removeEventListener('shopify:section:unload',cleanup); }
      });
    });
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open="mobile-dialog"]')) {
      const trigger = event.target.closest('[data-open="mobile-dialog"]');
      trigger.setAttribute('aria-expanded', String(Boolean(document.getElementById('mobile-dialog')?.open)));
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
